import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import firstimage from '@assets/placementpage-images/guyone (1).png';
import secondimage from '@assets/placementpage-images/guyone (2).png';
import thirdimage from '@assets/placementpage-images/guyone (3).png';
import fourthimage from '@assets/placementpage-images/guyone (4).png';
import fiveimage from '@assets/placementpage-images/guyone (5).png';
import siximage from '@assets/placementpage-images/guyone (6).png';
import sidelines from '@assets/placementpage-images/sidelines.svg';
import bgLines from '@assets/placementpage-images/bglines.svg';
import multipleLines from '@assets/placementpage-images/multiple-lines.png';
import cn from 'classnames';
import useMediaQuery from '@utils/hooks/useMediaQuery';

const CareerTrackPage = () => {
  const imageArray = [
    {
      id: 1,
      img: firstimage,
    },
    {
      id: 2,
      img: secondimage,
    },
    {
      id: 3,
      img: thirdimage,
    },
    {
      id: 4,
      img: fourthimage,
    },
    {
      id: 5,
      img: fiveimage,
    },
    {
      id: 6,
      img: siximage,
    },
    {
      id: 7,
      img: secondimage,
    },
  ];
  const isMobile = useMediaQuery('(max-width: 767.98px)');

  return (
  <div className={!isMobile ? "container relative mx-auto px-4 py-12" : ""}>

      <div
        className={cn(
          'relative mx-auto overflow-hidden rounded-3xl bg-[#FFF5F7] md:max-w-6xl',
          isMobile ? 'w-full rounded-none' : 'max-w-6xl'
        )}
        style={{
          borderRadius: isMobile ? '0px' : '32px',
          border: '1px solid #FFE8ED',
          background:
            'linear-gradient(108deg, rgba(255, 232, 237, 0.80) 19.63%, #FFF 48.68%, rgba(255, 232, 237, 0.80) 66.11%)',
        }}
      >
        <div className="relative px-6 pt-12 md:px-12">
          <div className="text-center">
            <div className="mb-2">
              <span className="font-proxima-nova text-[14px] md:text-lg font-semibold  leading-[120%] tracking-[-0.36px] text-[#F00037]">
                100%{' '}
              </span>
              <span className="font-proxima-nova text-[14px] md:text-lg font-normal leading-[120%] tracking-[-0.36px] text-[#3D3D3D]">
                Job Assurance with AlmaX Career Track
              </span>
            </div>

            <h1 className="mb-8 font-proxima-nova-bold text-[28px] md:text-[40px] font-semibold leading-[120%] tracking-[-0.8px]">
              <span className="font-proxima-nova-bold text-[#1F1F1F]">Take a </span>
              <span className="font-proxima-nova-bold text-[#F00037]">Moonshot</span>
              <span className="font-proxima-nova-bold text-[#1F1F1F]"> at your Tech Career</span>
            </h1>

            {/* Buttons */}
            <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
              <Link href="/courses">
                <button
                  className="flex  h-[48px] w-full items-center justify-center gap-3 rounded-[6px] bg-[#F00037] px-6 text-lg  font-medium capitalize leading-[20px] tracking-[0.26px] text-white [font-feature-settings:'liga'_off,'clig'_off] md:w-auto"
                  style={{ padding: '8px 24px' }}
                >
                  <span className="font-proxima-nova-bold text-[14px] md:text-[18px] font-bold capitalize leading-[20px] tracking-[0.26px] text-white [font-feature-settings:'liga'_off,'clig'_off]">
                    Explore Courses
                  </span>
                </button>
              </Link>
              <Link href="/admissions">
                <span className="font-proxima-nova text-[14px] md:text-base font-medium capitalize leading-[20px] tracking-[0.26px] text-[#F00037] underline decoration-[#F00037] decoration-solid [font-feature-settings:'liga'_off,'clig'_off] [text-decoration-skip-ink:none] [text-underline-position:from-font]">
                  Talk To Admissions Team
                </span>
              </Link>
            </div>
          </div>

          <div className="relative mt-20 flex justify-center">
            {/* Background lines */}
            <div
              className="absolute inset-0 flex items-center justify-center"
              style={{
                width: '2200px',
                marginTop: '430px',
                zIndex: 1,
                left: '-550px',
              }}
            >
              <Image
                src={multipleLines}
                alt="Background Lines"
                className="object-contain opacity-100" // Adjust height and opacity for better visibility
              />
            </div>

            {/* Images */}
            <div className="relative top-2 flex items-center space-x-0 md:-space-x-4">
              {imageArray?.map((item, index) => (
                <div
                  key={item.id}
                  className="relative transition-transform hover:z-10 hover:scale-110"
                  style={{
                    transform: `translateX(${index * -10}px)`,
                    zIndex: imageArray.length - index,
                  }}
                >
                  <Image
                    src={item.img}
                    alt={`Team Member ${item.id}`}
                    width={ 170}
                    height={229}
                    className="rounded-lg object-contain"
                    priority
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerTrackPage;
